<template>
    <div style="min-height: 85vh" class="ukpadding uk-background-muted">
      <div class="uk-container">
        <div class="uk-margin-large-top uk-margin-large-bottom">
         <h1 class="uk-heading-line uk-text-center">Departments Extensions</h1>
          <form class="uk-search uk-search-large">
            <span uk-search-icon></span>
            <input class="uk-search-input" type="search" placeholder="Search..." v-model="search">
          </form>


          <div>

            <div class="uk-child-width-1-1" uk-grid>
              <div v-for="deps in filterDep" style="margin-top: 15px !important;">
                <div class="uk-card uk-card-hover uk-card-body" style="padding: 15px">
                  <div>
                    <h3 class="uk-card-title specHeading uk-margin-small-bottom">{{deps.name}}</h3>
                    <div class=""><span class="uk-text-small uk-margin-bottom" style="color: rgb(197, 179, 97);">Matters:</span> <span class="uk-text-bold uk-text-small">{{deps.matters}}</span></div>
                    <div class=""><span class="uk-text-small uk-margin-bottom" style="color: rgb(197, 179, 97);">Extension:</span> <span class="uk-text-bold uk-text-small">{{deps.extensions}}</span></div>
                    <div><span class="uk-text-small uk-margin-top"  style="color: rgb(197, 179, 97);">Email: </span>
                      <span class="uk-text-bold uk-text-small uk-text-primary">{{deps.email}}</span></div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "searchDepartment",
      data(){
          return{
            search:''
          }

      },
      computed:{
          GetDep(){
            return this.$store.state.updatedDirectory
          },

        filterDep: function(){
          const search = new RegExp(this.search, 'i');

          return this.GetDep.filter((deps) =>{
            return deps.name.match(search)
          })
        }




      }


    }
</script>

<style scoped>
.uk-card{
  background-color: white;
}
</style>
